<template>
  <div v-if="layoutStore.breadcrumbsVisibility" :class="$style.breadcrumbs">
    <SCAOverflowContainer type="SCATag" :items="breadcrumbs" style="--sca-overflow-container-gap: 0" />
  </div>
</template>
<script setup lang="ts">
import { SCAOverflowContainer } from "@scayla/components";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import type { RouteRecordNormalized } from "vue-router";
import { useRoute, useRouter } from "vue-router";

import { Routes } from "@/router";
import { useLayoutStore } from "@/store/layoutStore";

const { t: $t } = useI18n();

const route = useRoute();
const router = useRouter();
const layoutStore = useLayoutStore();

// Some paths exist only to group children — such crumbs must stay labels only.
function isNavigable(record: RouteRecordNormalized): boolean {
  if (record.redirect) return true;
  return Object.keys(record.components ?? {}).length > 0;
}

const breadcrumbs = computed(() => {
  const bcList = route.matched.filter((r) => "breadcrumb" in r.meta);
  const home = {
    label: $t("common.label.home"),
    onClick: () => router.push({ name: Routes.HOME }),
    props: { selected: bcList.length === 0, variant: "breadcrumb" },
  };
  const items = bcList.map((bc, index) => {
    const navigable = isNavigable(bc);
    return {
      label: bc.meta.breadcrumb as string,
      onClick: navigable ? () => router.push({ name: bc.name, params: {} }) : undefined,
      props: { variant: "breadcrumb", selected: index === bcList.length - 1, disabled: !navigable },
    };
  });
  return [home, ...items];
});
</script>
<style lang="scss" module>
.breadcrumbs {
  align-items: center;
  width: 100%;
  min-width: 0;
  margin-left: -4px;
}
</style>
